import { createStore } from "vuex";
const store = createStore({
    state: {
  
        // Store api request results in the task list
        name: "Testing Vue State Management in store/index.js",
        // Play
        play: false
      

    },
    mutations: { 
        
      
    },
    actions: {

    },
    getters: {
      
    },
    modules: {
        

    }
})
export default store;